import { fetchApi } from '@/app/api';
import { first } from '@/lib/api-utils';
import { DTO, Label, MakeOptionalExcept, parseLabelDto } from '@certhon/models';
import { map } from 'remeda';

export function fetchLabels() {
  return fetchApi('/labels').then(map(parseLabelDto));
}

export function fetchLabel(recnum: number) {
  return fetchApi('/labels', { recnum: `eq.${recnum}` }).then(
    (arr: DTO<Label>[]) => {
      if (!arr.length) {
        throw new Error('could not find label');
      }
      return parseLabelDto(arr[0]);
    },
  );
}

export function createLabel(
  label: MakeOptionalExcept<
    Omit<Label, 'recnum' | 'created' | 'modified' | 'editor_user_id'>,
    'name'
  >,
): Promise<Label> {
  return fetchApi('/labels', undefined, {
    method: 'POST',
    body: JSON.stringify(label),
  })
    .then(first)
    .then(parseLabelDto);
}

export function updateLabel({
  recnum,
  ...updates
}: MakeOptionalExcept<Label, 'recnum'>): Promise<Label> {
  return fetchApi(
    '/labels',
    { recnum: `eq.${recnum}` },
    {
      method: 'PATCH',
      body: JSON.stringify(updates),
    },
  )
    .then(first)
    .then(parseLabelDto);
}

export async function deleteLabel(recnum: number) {
  await fetchApi(
    '/labels',
    { recnum: `eq.${recnum}` },
    {
      method: 'PATCH',
      body: JSON.stringify({ deleted: true }),
    },
  );
}
